<hr>
<div class="wrap" appChangeColorTheme attribute="border" rgba="0.2" borderPx="2px">
  <div class="sessions_list" *ngIf="!isLoading">
    <!-- <h4>Liste des sessions</h4> -->
    <div class="session_list_header" appChangeColorTheme attribute="bgc" rgba="0.1">
      <div>Nom</div>
      <div>Date</div>
      <div class="text_center trainee_reduce">Stag.</div>
      <div class="text_center trainee_complete">Quantité</div>
      <div class="text_center">Prix</div>
      <div class="text_center">Aperçu</div>
      <div class="text_center">Club</div>
    </div>

    <div class="session_list_content">
      <div class="session_line" *ngFor="let s of sessions"
        [ngClass]="{border_active: s.bookedSessionKey === sessionOverViewKey}">
        <div>{{s.sessionName ? s.sessionName : s.offer.offerName }}</div>
        <div>{{ s.sessionStartDate !== '0001-01-01T00:00:00Z' ?  (s.sessionStartDate  | date: 'shortDate':'UTC') : '-'}}</div>
        <div class="text_center session_quantity" (click)="changeSessionOverview(s, 'session_quantity')" appChangeColorTheme attribute="color">
          {{s.bookedSessionQuantity}}</div>
        <div class="text_center">{{s.bookedSessionAmount}}€</div>
        <div class="text_center">
          <fa-icon [icon]="getFaIcon('faImage')" (click)="changeSessionOverview(s)" appChangeColorTheme attribute="color"></fa-icon>
        </div>
        <div class="text_center">
          <fa-icon [icon]="getFaIcon('faInfoCircle')" [matTooltip]="getTooltip('detailsClub')"
            (click)="changeSessionOverview(s, 'club')" appChangeColorTheme attribute="color"></fa-icon>
        </div>
      </div>
    </div>

  </div>
  <mat-spinner *ngIf="isLoading" [diameter]="50"></mat-spinner>

  <app-session-booked-overview-session *ngIf="!showTrainee && !showClub " [session]="sessionOverView">
  </app-session-booked-overview-session>
  <app-session-booked-overview-trainee *ngIf="showTrainee" [trainees]="sessionOverViewTrainees"></app-session-booked-overview-trainee>
  <app-session-booked-overview-club *ngIf="showClub" [club]="sessionOverViewClub"></app-session-booked-overview-club>

</div>
